import styled from "@emotion/styled"
import "swiper/css"
import { Swiper, SwiperSlide } from "swiper/react"
import { mediaQueries, useIsDesktop } from "ui"
import InnerCardBoxItem from "../common/InnerCardBoxItem"

const StyledSwiper = styled(Swiper)`
  overflow: visible;
  .swiper-slide {
    width: 100%;
    height: 312px;
  }

  ${mediaQueries.mobile} {
    padding-top: 0;
    .swiper-wrapper {
      padding-inline-start: 24px;
    }
  }
  ${mediaQueries.tablet} {
    padding-top: 0;
    margin-inline-end: 0;
    .swiper-wrapper {
      padding-inline-start: 24px;
    }
  }
  ${mediaQueries.desktopM} {
    height: 100%;
    padding: 0;
    .swiper-wrapper {
      padding-inline-start: 0;
      justify-content: center;
    }
    .swiper-slide {
      height: 307px;
    }
  }
  ${mediaQueries.desktop} {
    .swiper-slide {
      height: 350px;
    }
  }
`
const StyledSwiperSlide = styled(SwiperSlide)`
  padding: 40px;
  border-radius: 30px;
  box-shadow: -8px 8px 30px 0px rgba(2, 1, 64, 0.08);
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(8px);
  display: flex;
  flex-direction: column;
  align-items: center;
`

const SwiperCarBoxesList = ({ itemsList }: any) => {
  const isDesktop = useIsDesktop()
  return (
    <StyledSwiper
      slidesPerView={isDesktop ? 4 : 1.2}
      spaceBetween={isDesktop ? 32 : 20}
      slidesOffsetAfter={isDesktop ? 0 : 36}
    >
      {itemsList?.blocks?.map((item: any, i: number) => {
        return (
          <StyledSwiperSlide key={i}>
            <InnerCardBoxItem item={item} />
          </StyledSwiperSlide>
        )
      })}
    </StyledSwiper>
  )
}

export default SwiperCarBoxesList
